class TokenService {
   
  
    getLocalAccessToken() {
      const accessToken = localStorage.getItem("authToken");
      return accessToken; 
    }
  
    updateLocalAccessToken(token) {
        localStorage.setItem("authToken", token);
    }
    
  }
  
  export default new TokenService();